import { SessionStorageKeys } from '@aglenergy/shared-library';
import { store } from 'app/shared/store/store';
import { AddressDetailModel } from 'app/shared/models/address/address.model';
import { CustomerType } from 'app/shared/models/productSearchRequestModel';
import { EnergyProductsResponse } from 'app/shared/models/product-response.model';
import { QueryStringParamName } from 'app/shared/models/common.enums';
import { SearchRequestType } from 'app/shared/models/energy/energy.enums';
import { bundleService } from 'app/shared/services/bundle/bundle.service';
import { customerProfileService } from 'app/shared/services/customer-profile/customerProfile-service';
import { energyProductSearchService } from 'app/energy/services/energy-product-search.service';
import { energyRequestMapper } from 'app/energy/mappers/energy-request.mapper';

class CrossSellService {
  private crossSellAvailableByAddress: { [address: string]: boolean } = {};

  public async loadCrossSellProducts(address: AddressDetailModel): Promise<void> {
    const isBundle = store.get('isExplicitBundleFlow');
    if (!isBundle) {
      sessionStorage.removeItem(SessionStorageKeys.BundleConfig);
    }
    const searchRequest = energyRequestMapper.mapToCurrentSearchRequestModel(
      address,
      CustomerType.residential,
      null,
      SearchRequestType.address
    );

    try {
      const energyProductsResponse: EnergyProductsResponse = await energyProductSearchService.getProducts(searchRequest);

      const isEnergyAvailable = !!energyProductsResponse?.electricity?.products?.length || !!energyProductsResponse?.gas?.products?.length;
      if (isEnergyAvailable) {
        this.setCrossSellFlowAvailableOnAddress(address.fullAddress);
      }
    } catch {
      // Remove isBundleExplicitlyRequestedByCustomer from customerProfile, to prevent cart.spa displaying cross sell
      const customerProfile = customerProfileService.getCustomerProfile();
      delete customerProfile.isBundleExplicitlyRequestedByCustomer;
      customerProfileService.setCustomerProfile(customerProfile);
      // this is to prevent error bubble up.
      return;
    }
  }

  public setCrossSellFlowAvailableOnAddress(address: string): void {
    this.crossSellAvailableByAddress[address] = true;
  }

  public isCrossSellFlowAvailableOnAddress(address: string): boolean {
    return this.isCrossSellFlow() && !!this.crossSellAvailableByAddress[address];
  }

  public isCrossSellFlow(): boolean {
    const urlParams = new URLSearchParams(window.location.search);
    const bridgePageOrigin = urlParams.get(QueryStringParamName.BridgePageOrigin);
    if (bridgePageOrigin) {
      return false;
    }
    return this.hasAGLFunnelSQ && !bundleService.isExplicitBundleFlow();
  }

  private get hasAGLFunnelSQ(): boolean {
    const aglFunnelSQParam = new URLSearchParams(window.location.search).get(QueryStringParamName.AGLFunnelSQ);
    return sessionStorage.getItem(SessionStorageKeys.AGLFunnelSQ)?.toLowerCase() === 'true' || aglFunnelSQParam === 'true';
  }

  public removeCrossSellProductCategory(): void {
    sessionStorage.removeItem(SessionStorageKeys.CrossSellProductCategory);
  }
}

export const crossSellService = new CrossSellService();
